import { setTimeoutWithDestroyRef } from 'src/app/core/utils/lifecycle-timeout';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { interval, Subscription , Subject, takeUntil} from 'rxjs';
import { BroadcastService } from 'src/app/core';
import { MsgConstantConfig } from 'src/app/core/config/message.constant.config';
import { MultilingualService } from 'src/app/core/modules/header/multilingual.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AuthComponent implements OnInit,OnDestroy {
  private readonly destroy$ = new Subject<void>();

  private readonly destroyRef = inject(DestroyRef);

  currentDate:string = '';
  currentTime:string = '';
  currentYear:string = moment().format('YYYY');
  eventSubscription:Array<Subscription> = [];
  sectionTitle:string = '';
  selected_range: any;

  constructor(private route:ActivatedRoute, private router:Router,
    private translateService:TranslateService,
    private multilingualService:MultilingualService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('Selected_Language') || 'en');

    const routeEvents = this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.sectionTitle  = this.route.snapshot.firstChild?.data?.title || '';
      }
    });
    this.eventSubscription.push(routeEvents);
  }

  ngOnInit(): void {
    this.multilingualService.currentLanguageResponse.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data) {
        this.selected_range = data ?? '';
        this.translateService.use(localStorage.getItem('Selected_Language') || 'en');
      }
    });
  }

  ngOnDestroy():void{
    this.destroy$.next();
    this.destroy$.complete();
    this.eventSubscription.forEach((event)=>event.unsubscribe());
  }
}
